import { render, staticRenderFns } from "./AddProductGroup.vue?vue&type=template&id=1e99ee0e&"
import script from "./AddProductGroup.vue?vue&type=script&lang=js&"
export * from "./AddProductGroup.vue?vue&type=script&lang=js&"
import style0 from "./AddProductGroup.vue?vue&type=style&index=0&id=1e99ee0e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports